export default function tracker(
  method: string,
  pixelId: string,
  event: string,
  data?: any
) {
  console.log("tracker", method, pixelId, event, data);
  //@ts-ignore
  if (fbq) {
    //@ts-ignore
    fbq(method, pixelId, event, data);
  }
  if (event == "Lead") {
    //@ts-ignore
    if (gtag) {
      //@ts-ignore
      gtag("event", 'generate_lead', {'send_to': "G-DE9JLYGSSZ"});
    }
  }
  else {
    //@ts-ignore
    if (gtag) {
      //@ts-ignore
      gtag("event", event, {'send_to': "G-DE9JLYGSSZ"});
    }
  }
}
